import * as angular from 'angular';
import LibraryFormThemesGridBridge from './LibraryFormThemesGridBridge';

angular
  .module('flowingly.runner.library')
  .component('libraryFormThemesGrid', LibraryFormThemesGridBridge);
